import module from 'fan/proyecto/module.js'
import config from './config.json'
import template from './template.html'
import { merge } from 'lodash'

const diacriticosRegex = /[\u0300-\u036f]/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').toUpperCase().trim()

const curpRegex = '[A-Z][A,E,I,O,U,X][A-Z]{2}[0-9]{2}[0-1][0-9][0-3][0-9][M,H][A-Z]{2}[B,C,D,F,G,H,J,K,L,M,N,Ñ,P,Q,R,S,T,V,W,X,Y,Z]{3}[0-9,A-Z][0-9]'

const rfcFisico = '^(([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|' +
  '(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|' +
  '(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|' +
  '(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$'

const rfcMoral = '^(([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|' +
  '(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|' +
  '(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|' +
  '(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$'

export class FanProyectoColaboradoresImportarExcelComponent {
  constructor ($parse, $q, FanProyectoColaboradoresPuestosService, FanProyectoColaboradoresRegistrosPatronalesService, FanProyectoColaboradoresDepartamentosService, FanProyectoColaboradoresPredeterminadoService) {
    this.$q = $q
    this.$parse = $parse
    this.FanProyectoColaboradoresPredeterminadoService = FanProyectoColaboradoresPredeterminadoService
    this.FanProyectoColaboradoresPuestosService = FanProyectoColaboradoresPuestosService
    this.FanProyectoColaboradoresDepartamentosService = FanProyectoColaboradoresDepartamentosService
    this.FanProyectoColaboradoresRegistrosPatronalesService = FanProyectoColaboradoresRegistrosPatronalesService
    this.headers = []
    this.idProyecto = undefined
    this.onChange = undefined
    this.alertas = []
    this.error = null
    this.catalogos = {
      departamentos: [],
      puestos: [],
    }
  }

  $onInit () {
    config.headers.forEach((item) => {
      let processor = this.$parse(item.id)
      let match = [item.name.toUpperCase(), item.id.toUpperCase()]

      this.headers.push({
        id: item.id,
        name: item.name,
        group: item.group.toUpperCase(),
        parser: (value) => (parse(value, item.type)),
        processor: (object, value) => {
          if (typeof value !== 'undefined') {
            processor.assign(object, value)
          }

          return object
        },
        match: (value) => (match.indexOf(value.toUpperCase()) >= 0),
      })
    })

    this.promise = this.$q.all([
      this.FanProyectoColaboradoresDepartamentosService.get(this.idProyecto)
        .then((response) => (this.catalogos.departamentos = response.data)),
      this.FanProyectoColaboradoresRegistrosPatronalesService.get(this.idProyecto)
        .then(({data}) => (this.catalogos.registrosPatronales = data)),
      this.FanProyectoColaboradoresPuestosService.get(this.idProyecto)
        .then((response) => (this.catalogos.puestos = response.data)),
      this.FanProyectoColaboradoresPredeterminadoService.get(this.idProyecto)
        .then((response) => (this.model = function Modelo () {
          merge(this, response.data)
        })),
    ])
  }

  validar (event) {
    this.error = null
    this.alertas = []

    if (!event.data || !event.headers) {
      this.onChange({$event: {data: null}})

      return
    }

    if (event.headers.indexOf('contrato.tipo_salario_id') < 0) {
      return this.error = 'No se encontró la columna tipo de salario'
    }

    if (event.headers.indexOf('contrato.tipo_colaborador_id') < 0) {
      return this.error = 'No se encontró la columna tipo de colaborador'
    }

    if (event.headers.indexOf('contrato.clase') < 0) {
      return this.error = 'No se encontró la colomna "clase"'
    }

    if (event.headers.indexOf('cliente.departamento') < 0) {
      return this.error = 'No se encontró la columna "departamento"'
    }

    if (event.headers.indexOf('cliente.puesto') < 0) {
      return this.error = 'No se encontró la columna "puesto"'
    }

    let data = event.data.filter(({cliente, contrato, personal, cuenta}, indice) => {

      if (!cliente.departamento) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna departamento esta vacía`)
        return false
      }

      if (!cliente.puesto) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna puesto esta vacía`)
        return false
      }

      if (!contrato.tipo_salario_id && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna tipo salario esta vacía`)
        return false
      }

      if (!+contrato.tipo_salario_id && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna tipo salario no tiene el formato correcto`)
        return false
      }

      if (!contrato.tipo_colaborador_id && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna tipo colaborador esta vacía`)
        return false
      }

      if (!personal.curp.match(curpRegex) && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues no tiene el curp en el formato correcto`)
        return false
      }

      if (!(personal.rfc.match(rfcFisico) || personal.rfc.match(rfcMoral)) && +contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues no tiene un RFC válido`)
        return false
      }

      if (!+contrato.tipo_colaborador_id && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna tipo colaborador no tiene el formato correcto`)
        return false
      }

      if (!contrato.id_jornada && !contrato.id_jornada && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna tipo de jornada no tiene el formato correcto`)
        return false
      }

      if (!contrato.id_tipo_contrato && !contrato.id_tipo_contrato && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna tipo de jornada no tiene el formato correcto`)
        return false
      }

      if (contrato.id_tipo_contrato < 9 && contrato.id_regimen_fiscal === 9) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues el contrato no pertenece al régimen 'asimilados'`)
        return false
      }

      if (!contrato.conceptoContrato && contrato.id_regimen_fiscal === 9) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues no hay un concepto de contrato en el régimen 'asimilados'`)
        return false
      }

      if (contrato.id_tipo_contrato >= 9 && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues el contrato no pertenece al régimen 'Sueldos y salarios'`)
        return false
      }

      if (!contrato.id_peridiocidad && !contrato.id_peridiocidad && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice} pues la columna tipo de nómina no tiene el formato correcto`)
        return false
      }

      if (!contrato.id_peridiocidad && !contrato.id_peridiocidad && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice} pues la columna tipo de nómina no tiene el formato correcto`)
        return false
      }

      if (!contrato.salario_neto_integral && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna salario neto integral esta vacía`)

        return false
      } else {
        let finito = Number.isFinite(contrato.salario_neto_integral)
        if (!finito) {
          this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna salario neto integral no tiene el formato correcto`)

          return false
        }
      }

      if (!contrato.salario_diario && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna salario diario no tiene el formato correcto`)

        return false
      }

      if (!contrato.salario_diario_integrado && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna salario diario integrado no tiene el formato correcto`)

        return false
      }

      if (contrato.salario_diario && contrato.salario_diario_integrado) {
        if (contrato.salario_diario >= +contrato.salario_diario_integrado) {
          this.alertas.push(`Se omitirá la fila #${indice + 1} pues el salario diario es menor a salario diario integrado`)

          return false
        }
      }

      if (!contrato.salario_neto_mensual && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna salario neto mensual esta vacía`)

        return false
      } else if (contrato.id_regimen_fiscal === 2) {
        let finito = Number.isFinite(contrato.salario_neto_mensual)
        if (!finito) {
          this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna salario neto mensual no tiene el formato correcto`)

          return false
        }
      }

      if (!contrato.clase && contrato.id_regimen_fiscal === 2) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues la columna clase no se especificó.`)

        return false
      }

      if (contrato.id_regimen_fiscal === 2) {
        let registro = this.registroPatronalNoValido(contrato.registroPatronal, contrato.clase)
        if (!registro) {
          this.alertas.push(`Se omitirá la fila #${indice + 1} pues el registro patronal no pertenece a la clase indicada.`)
          return false
        }else {
          contrato.registroPatronalId = registro.id
        }
      }

      cliente.departamento = normalizar(cliente.departamento)
      cliente.puesto = normalizar(cliente.puesto)
      cliente.departamento = this.catalogos.departamentos
        .find((departamentos) => normalizar(departamentos.descripcion) === cliente.departamento)
      cliente.puesto = this.catalogos.puestos
        .find((puestos) => normalizar(puestos.descripcion) === cliente.puesto)

      cliente.id_departamento = (cliente.departamento ? cliente.departamento.id : null)
      cliente.id_puesto = (cliente.puesto ? cliente.puesto.id : null)

      if (!cliente.id_departamento) {
        this.alertas.push(`Se omitirá fila #${indice + 1} pues el departamento no pudo se encontrado`)
        return false
      }

      if (contrato.id_regimen_fiscal === 2) {
        if (!contrato.tipo_colaborador_id || !contrato.tipo_salario_id) {
          this.alertas.push(`Se omitira fila #${indice + 1} pues es régimen fiscal "sueldos y salarios" y es obligadorio los campos tipo colaborador y tipo salario`)
          return false
        }
      }

      if (!cliente.id_puesto) {
        this.alertas.push(`Se omitirá fila #${indice + 1} pues el puesto no pudo se encontrado`)
        return false
      }

      if (!personal.nombre || !personal.apellido_paterno) {
        this.alertas.push(`Se omitirá la fila #${indice + 1} pues no tiene asignado un nombre`)
        return false
      }

      if (!personal.apellido_materno) {
        this.alertas.push(`El colaborador ${personal.nombre} en la fila ${indice + 1} no tiene apellido materno`)
      }

      if (cuenta.id_banco && cuenta.id_moneda) {
        if (!cuenta.numero_cuenta && !cuenta.numero_tarjeta && !cuenta.clabe) {
          this.alertas.push(`Se definió banco y moneda, pero no existe número de cuenta, número de tarjeta o CLABE en la fila #${indice + 1} `)
        }
      }

      return true
    })

    this.onChange({$event: {data: this.error ? null : data}})
  }

  registroPatronalNoValido (registroPatronal, clase) {
    return this.catalogos.registrosPatronales.find(i => i.registroPatronal === registroPatronal && i.clase === clase)
  }
}

function parse (value, type) {
  switch (type) {
    case 'text': {
      return value ? value.trim() : undefined
    }

    case 'int': {
      let int = parseInt(value)
      return int >= 0 ? int : undefined
    }

    case 'float': {
      let float = parseFloat(value)
      return float >= 0 ? float : undefined
    }

    case 'date': {
      return value ? new Date(Date.parse(value.replace('-', '/', 'g'))) : undefined
    }

    default: {
      return undefined
    }
  }
}

module.component('fanProyectoColaboradoresImportarExcel', {
  controller: FanProyectoColaboradoresImportarExcelComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/importar/excel/component.js